import React, { useState, useEffect, useRef } from "react";
import FormInputStyle4 from "../../UIElements/FormInput";
import FormSelectStyle4 from "../../UIElements/FormSelect";
import FormButtonStyle4 from "../../UIElements/FormButton";
import ImageRadioButton from "../../UIElements/ImageRadioButtons";
import _ from "lodash";
import { setUserClickData } from "../../../../utility/setUserClickData";
import { toast } from "react-toastify";
import { getAllianceLeadFromMoneyTapInput } from "../../../../utility/commonUtils";
import { useDispatch, useSelector } from "react-redux";
import callApi from "../../../../utility/apiCaller";
import { useSearchParams } from "react-router-dom";
import { mapLeadRequestToResponse } from "../../Utils/leadmapperfunction";
import useAddLead from "../../hooks/addLeadtoCRM";
import Spinner from "../Spinner/spinner";
import { setAllOffers, setOffers } from "../../../../store/app/appReducer";
import { getCurrentLocation } from "../../Utils/GeoLocation";
import { setAAurl as SetAAUrlInstore } from "../../../../store/app/aaSlice";
import { setSelectedOffer as setOfferToStore } from "../../../../store/app/aaSlice";
import {
  setAppId,
  setInternalLead,
  setLeadId,
  setResponse,
  setUserData,
} from "../../../../store/app/aaSlice";
import useUserEvent from "../../../../hooks/setUserclickhook";
import { LoadingScreen } from "../FetchingOfferLoader/fetchingOffer";
import StickyCtaBar from "../../UIElements/StickyCtaBar";

const callApiWithRetryAndTest = async (
  apiFunc,
  retries,
  delay,
  testFunc,
  errorMsg
) => {
  return await withRetry(
    async () => {
      const res = await apiFunc();
      console.log(res);
      if (testFunc && !testFunc(res)) {
        throw new Error(errorMsg || "Validation failed");
      }
      return res;
    },
    retries,
    delay
  );
};

const isHero = (offers) => {
  const heroId = "67ef646df80610d286084e60";
  return offers.some((o) => o.lender_id === heroId);
};
const isLT = (offers) => {
  const Id = "662752eb65fdba1a48d6e482";
  return offers.some((o) => o.lender_id === Id);
};

const isDMI = (offers) =>
  offers.some((o) => o.lender_id === "68ad8ed5078abf6c677e4303");

const HERO_ID = "67ef646df80610d286084e60";
const LT_ID = "662752eb65fdba1a48d6e482";
const DMI_ID = "68ad8ed5078abf6c677e4303";

const withRetry = async (fn, retries = 3, delay = 1000) => {
  let attempt = 0;
  while (attempt < retries) {
    try {
      return await fn();
    } catch (err) {
      attempt++;
      if (attempt >= retries) throw err;
      console.warn(`Retrying... attempt ${attempt}`);
      await new Promise((res) => setTimeout(res, delay * attempt)); // backoff
    }
  }
};

function ProfessionalInformationForm({
  formData,
  setFormData,
  currentStep,
  setCurrentStep,
  setLead_id,
  setApplicationId,
  setResponseId,
  setMappedResponse,
  setAAUrl,
  setInternalLeadId,
}) {
  const [company_name, setcompany_name] = useState("");
  const [company_type, setcompany_type] = useState("");
  const [work_contact_email, setWorkEmail] = useState("");
  // const [failedList, setFailedList] = useState([]);
  const [activeLenders, setActiveLenders] = useState([]);
  const [isFinished, setIsFinished] = useState(false);
  const [monthly_income, setIncome] = useState("");
  const [loan_purpose, setloan_purpose] = useState("");
  const [professionType, setProfessionType] = useState("");
  const [errors, setErrors] = useState({});
  const [ownership, setOwnership] = useState("");
  const [hasOffer, setHasOffer] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector((state) => state.app.user);
  const [params] = useSearchParams();
  const [isFetchingOffers, setIsFetchingOffers] = useState(false); // <-- new state
  const [offersReady, setOffersReady] = useState(false);
  const nextStepRef = useRef(6);
  const dispatch = useDispatch();
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [leadResponse, setLeadResponse] = useState({});
  // const [ip_address, setIp] = useState(null);
  const mobile = localStorage.getItem("mobile");
  const [timer, setTimer] = useState(null);
  const { trackUserEvent } = useUserEvent();
  // const [internalLeadId, setInternalLeadIdstate] = useState(null);
  const aaSlice = useSelector((state) => state?.aa);
  let leadId = null;
  let aaReq = false;
  const InternalLeadId = aaSlice?.internalLeadId;
  const addLead = useAddLead();
  const affId = params.get("aff_id");
  useEffect(() => {
    //console.log("leadResponse: ", leadResponse);
  }, [leadResponse]);

  const options = [
    {
      label: "Owned",
      value: "owned",
      selectedImage: "/images/selected.png",
      unselectedImage: "/images/unselected.png",
    },
    {
      label: "Rented",
      value: "rented",
      selectedImage: "/images/selected.png",
      unselectedImage: "/images/unselected.png",
    },
  ];

  useEffect(() => {
    const captureLocation = () => {
      getCurrentLocation(
        ({ latitude, longitude }) => {
          setLatitude(latitude);
          setLongitude(longitude);
          //console.log("Latitude:", latitude, "Longitude:", longitude);
        },
        (error) => {
          console.error("Failed to get location:", error.message);
        }
      );
    };
    captureLocation();
    // const fetchIp = async () => {
    //   try {
    //     const res = await fetch("https://api.ipify.org?format=json");
    //     const data = await res.json();
    //     setIp(data.ip);
    //     //console.log("ip address:", data.ip);
    //   } catch (error) {
    //     console.error("Error fetching IP:", error);
    //   }
    // };
    // fetchIp();
  }, [formData]);

  const fetchActiveLenders = async () => {
    try {
      const res = await callApi(`v1/lender/active-lenders`, "get", {}, "loan");
      if (res.status === "Success") {
        const apiLenders = res.data.lenderList ?? [];

        // const hardcodedLender = {
        //   _id: "662752eb65fdba1a48d6e482",
        //   lender_name: "L&T",
        // };

        const mergedLenders = [...apiLenders];

        setActiveLenders(mergedLenders);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // Load initial data if available
  useEffect(() => {
    if (formData) {
      setcompany_name(formData.company_name || "");
      setcompany_type(formData.company_type || "");
      setWorkEmail(formData.work_contact_email || "");
      setIncome(formData.monthly_income || "");
      setloan_purpose(formData.loan_purpose || "");
      setProfessionType(formData.professionType || "");
      setOwnership(formData.ownership || "");
    }
  }, [formData]);

  // Live validation check
  useEffect(() => {
    const allValid =
      company_name.trim() &&
      company_type &&
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(work_contact_email) &&
      monthly_income &&
      !errors.monthly_income &&
      loan_purpose;

    setIsFormValid(allValid);
  }, [
    company_name,
    company_type,
    work_contact_email,
    monthly_income,
    errors.monthly_income,
    loan_purpose,
    ownership,
  ]);

  const handleIncomeChange = (e) => {
    let value = e.target.value;

    // Remove non-digit characters
    value = value.replace(/\D/g, "");

    setIncome(value); // Store the cleaned numeric value
    if (value === "" || isNaN(Number(value)) || Number(value) < 25000) {
      setErrors((prev) => ({
        ...prev,
        monthly_income: "Income should be greater than ₹25,000",
      }));
    }

    if (timer) {
      clearTimeout(timer);
    }
    const rawValue = value;

    const newTimer = setTimeout(() => {
      // Already cleaned

      if (Number(rawValue) < 25000 && rawValue !== "") {
        setErrors((prev) => ({
          ...prev,
          monthly_income: "Income should be greater than ₹25,000 ",
        }));
      } else {
        setErrors((prev) => {
          const { monthly_income, ...rest } = prev;
          return rest; // Clear error if valid
        });
      }
    }, 100);

    setTimer(newTimer);
  };

  const pushHDMLead = async (leadId) => {
    if (affId !== "2") return;
    try {
      const res = await callApi(
        "v1/lead/hdm_lead_push",
        "post",
        { lead_id: leadId },
        "core",
        user?.token
      );

      return res; // return response to caller
    } catch (err) {
      console.error("HDM lead push failed:", err);
      return { status: "Error", error: err };
    }
  };

  const getleadData = async () => {
    const leadRes = await callApi(
      `v1/lead/list`,
      "post",
      {
        filters: {
          _id: InternalLeadId,
        },
      },
      "core",
      user?.token ||
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OTAxYjljZjIxZTZlNTJmYTQwNDAwNDkiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk2OTMxMzU0NjYiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMC0yOVQwNzowMzowMy43MDZaIiwiaWF0IjoxNzYxNzIwNzg3fQ.xJ3Qd29aQPzV6vfc-bm5XDaOyIF1dXI4dD3lRZxEBDo"
    );
    console.log(leadRes.data.leadList[0]);
    const leadData = leadRes?.data?.leadList[0];

    const { application_id } = leadData;
  };

  // Handle validation
  const handleValidation = () => {
    const newErrors = {};

    if (!company_name.trim()) newErrors.company_name = true;
    if (!professionType) newErrors.professionType = true;
    if (!monthly_income) newErrors.monthly_income = true;
    if (!loan_purpose) newErrors.loan_purpose = true;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Submit form
  const handleSubmit = async () => {
    if (!handleValidation()) return;

    setUserClickData({
      event_name: `professional-details-multistep-pl-v1`,
      user_id: formData?.mobile || "unknown",
      affiliate_id: affId || "No Aff_id found",
      utm_source: params.get("utm_source") || params.get("utm_medium"),
      utm_term: params.get("utm_term"),
    });

    try {
      setIsLoading(true);
      setIsFetchingOffers(true);
      setOffersReady(false);

      // Update parent form data
      const updatedFormData = {
        ...formData,
        contact_phone: formData.mobile,
        company_name,
        company_type,
        work_contact_email,
        monthly_income,
        loan_purpose,
        professionType,
        ownership,
        city: formData.city,
        state: formData.state,
        latitude,
        longitude,
        // ip_address,
      };

      setFormData(updatedFormData);

      // Step 1: Lead generation
      const res = await callApi(
        `v1/lead/${InternalLeadId}/update-lead-new`,
        "post",
        {
          lead: {
            company_name: company_name || "",
            company_type: company_type || "",
            work_contact_email: work_contact_email || "",
            monthly_income: monthly_income || "",
            loan_purpose: loan_purpose || "",
            profession_type: professionType || "",
            ownership: ownership || "",
            latitude: String(latitude),
            longitude: String(longitude),
            // ip_address: ip_address,
            steps_completed: 3,
          },
        },
        "core",
        user?.token ||
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OTAxYjljZjIxZTZlNTJmYTQwNDAwNDkiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk2OTMxMzU0NjYiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMC0yOVQwNzowMzowMy43MDZaIiwiaWF0IjoxNzYxNzIwNzg3fQ.xJ3Qd29aQPzV6vfc-bm5XDaOyIF1dXI4dD3lRZxEBDo"
      );
      // let processLeadRes = await callApi(
      //   "v1/lead/process-lead-for-loan-zv4",
      //   "post",
      //   { contact_phone: mobile || formData.mobile },
      //   "core",
      //   user.token
      // );
      ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
      const ltResponse = await callApi(
        "v1/lender_api_call/list",
        "post",
        {
          filters: {
            lead_id: InternalLeadId,
            lender_name: {
              $in: ["DMI", "Hero Fincorp","Prefr Preapproved","Muthoot"],
            },
          },
          pageSize: 10,
          pageNum: 1,
        },
        "loan_service"
      );

      const lendersData = await callApi(
        "v1/lender/list",
        "post",
        {
          filters: {
            name: { $in: ["DMI", "Hero Fincorp","Prefr Preapproved","Muthoot"] },
          },
          pageSize: 10,
          pageNum: 1,
        },
        "loan_service",
        user.token
      );

      // safe helpers
      const hasLenderCall = (name) =>
        (ltResponse?.data?.lender_api_callList || []).some(
          (entry) => entry.lender_name === name
        );

      const getLenderMeta = (name) =>
        (lendersData?.data?.lenderList || []).find((l) => l.name === name) ||
        null;

      // ---- Gold / PL routing + conditional big-lender push ----
      const GOLD_LENDER_IDS = [
        "69a2c7ab1f6f4ddfd5577314", // IIFL Finance
        "69ea0b864084a68bdadc40bd", // Muthoot Finance
        "6abb59d6a3ee46254d954755", // Oro Money
        "6ac37efdf072975a2b2502a2", // Capri Global 
        "6ac73876ff51f5d7328d7ca1", // Muthoot FinCorp
        "6aa03dd160f34db15292641e", // Rupeek
        //"6a2818d365c271100d17551e", // Manipal Fintech
      ];
      const PUSH_TRIGGER_LENDER_IDS = [
        "662752eb65fdba1a48d6e466", // KreditBee
        "662752eb65fdba1a48d6e464", // MoneyView
        "6851271c3a9753dd00d85475", // FatakPay
        "662752eb65fdba1a48d6e47a", // Zype
        "6a6ed6aefe1e854b8cbdf86a", //CredFin
      ];
      const PUSH_AMOUNT_RANGES = ["1-3l", "3-5l", "5-10l", "10l+"];

      // NOTE: offer generation, the big-lender push decision, and routing all
      // happen AFTER the poll below — we must have real offers before deciding.

      
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////
      // let processLeadRes = await withRetry(
      //   () =>
      //     callApi(
      //       "v1/lender/dmi-create-application?lender_id=67b82660c4058e568491673c",
      //       "post",
      //       {
      //         contact_phone: mobile || formData.mobile,
      //         id: InternalLeadId,
      //       },
      //       "loan"
      //     ),
      //   1, // retry once
      //   2000 // wait 2s before retry
      // );
      // if (processLeadRes?.status === "Success") {
      // Poll for offers, but DON'T stop on the very first one — keep going until
      // the offer count stops growing (stable across two polls) or we hit the
      // cap (~30s). This ensures ALL offers that land in the window are shown,
      // not just the first lender to respond.
      const pollOffers = async (attempt = 1, prevCount = -1) => {
        const result = await fetchOffers(InternalLeadId);
        const count = result?.offers?.length || 0;

        if (result?.success && count > 0) {
          setHasOffer(true);
          dispatch(
            setAllOffers({
              offers: result.offers,
              failedList: result.failedList,
            })
          );
        }

        // done when the count has settled (same as the previous poll, and > 0)
        if (count > 0 && count === prevCount) return result;
        // or when we hit the cap
        if (attempt >= 6) {
          return result || { success: false, offers: [], failedList: [] };
        }

        // otherwise wait 5s and poll again, remembering the current count
        return new Promise((resolve) =>
          setTimeout(
            async () => resolve(await pollOffers(attempt + 1, count)),
            5000
          )
        );
      };


      await callApi(
        "v1/lead/process-lead-for-loan-zv4",
        "post",
        { contact_phone: mobile || formData.mobile },
        "core",
        user.token
      ).catch(() => {});

      // Poll for the offers generated by the waterfall.
      let result = await pollOffers();

      // 3) Decide the big-lender push from the offers we ACTUALLY have now.
      const shouldPushBigLenders =
        ((result?.offers) || []).some((o) =>
          PUSH_TRIGGER_LENDER_IDS.includes(o.lender_id)
        ) &&
        PUSH_AMOUNT_RANGES.includes(formData.amountRange) &&
        Number(formData.monthly_income) > 35000;

      // 4) Push DMI / Hero / Prefr / Muthoot (only when the trigger conditions are met).
      if (shouldPushBigLenders) {
        const dmiMeta = getLenderMeta("DMI");
        if (!hasLenderCall("DMI") && dmiMeta && dmiMeta.bulk_api_push === true) {
          await callApi(
            "v1/lead/bulk-lead-push-by-leadId",
            "post",
            {
              leads: [{ lead_id: InternalLeadId }],
              lender_name: "DMI",
              lender_id: dmiMeta._id || "68ad8ed5078abf6c677e4303",
            },
            "core",
            user.token
          );
        }
        const heroMeta = getLenderMeta("Hero Fincorp");
        if (!hasLenderCall("Hero Fincorp") && heroMeta && heroMeta.bulk_api_push === true) {
          await callApi(
            "v1/lead/bulk-lead-push-by-leadId",
            "post",
            {
              leads: [{ lead_id: InternalLeadId }],
              lender_name: "Hero Fincorp",
              lender_id: heroMeta._id || "67ef646df80610d286084e60",
            },
            "core",
            user.token
          );
        }
        const prefrMeta = getLenderMeta("Prefr Preapproved");
        if (!hasLenderCall("Prefr Preapproved") && prefrMeta && prefrMeta.bulk_api_push === true) {
          await callApi(
            "v1/lead/bulk-lead-push-by-leadId",
            "post",
            {
              leads: [{ lead_id: InternalLeadId }],
              lender_name: "Prefr Preapproved",
              lender_id: prefrMeta._id || "667ffb7b0dd50ee1bb6556c5",
            },
            "core",
            user.token
          );
        }
        const muthootMeta = getLenderMeta("Muthoot");
        if (!hasLenderCall("Muthoot") && muthootMeta && muthootMeta.bulk_api_push === true) {
          await callApi(
            "v1/lead/bulk-lead-push-by-leadId",
            "post",
            {
              leads: [{ lead_id: InternalLeadId }],
              lender_name: "Muthoot",
              lender_id: muthootMeta._id || "67d29384aff96a3e586b1e89",
            },
            "core",
            user.token
          );
        }

        // 5) Poll until DMI / Hero / Prefr / Muthoot each respond (success or fail) or cap.
        const BIG_LENDER_IDS = [
          "68ad8ed5078abf6c677e4303", // DMI
          "67ef646df80610d286084e60", // Hero Fincorp
          "667ffb7b0dd50ee1bb6556c5", // Prefr Preapproved
          "67d29384aff96a3e586b1e89", // Muthoot
        ];
        for (let i = 0; i < 6; i++) {
          const responded = new Set(
            [
              ...((result?.offers) || []).map((o) => o.lender_id),
              ...((result?.failedList) || []).map((f) =>
                f && typeof f === "object" ? f.lender_id : null
              ),
            ].filter(Boolean)
          );
          if (BIG_LENDER_IDS.every((id) => responded.has(id))) break;
          await new Promise((r) => setTimeout(r, 5000));
          const r = await fetchOffers(InternalLeadId);
          if (r?.success) {
            result = r;
            dispatch(
              setAllOffers({ offers: r.offers, failedList: r.failedList })
            );
          }
        }
      }

      // 6) Route: PL vs Gold (IIFL / Muthoot / Manipal). No PL at all -> Gold
      //    page; otherwise the offer page (PL + Gold together).
      const finalOffers = (result?.offers) || [];
      const plOffers = finalOffers.filter(
        (o) => !GOLD_LENDER_IDS.includes(o.lender_id)
      );
      const goldOffers = finalOffers.filter(
        (o) => GOLD_LENDER_IDS.includes(o.lender_id)
      );
      nextStepRef.current = plOffers.length === 0 && goldOffers.length > 0 ? 56 : 6;
      setOffersReady(true); // loader finishes to 100%, then its onComplete redirects
      // await pushHDMLead(InternalLeadId);
      // if (hasOffer) {
      //   try {
      //     await addLead({
      //       leadId: InternalLeadId,
      //       lead_type: "live",
      //       priority: 2,
      //       stage: "Have offer",
      //     });
      //   } catch (error) {
      //     console.error("Error adding lead to CRM:", error);
      //   }
      // } else {
      //   try {
      //     await addLead({
      //       leadId: InternalLeadId,
      //       lead_type: "live",
      //       priority: 2,
      //       stage: "Professional Details",
      //     });
      //   } catch (error) {
      //     console.error("Error adding lead to CRM:", error);
      //   } finally {
      //     setCurrentStep(6);
      //   }
      // }
      // }
    } catch (err) {
      console.error(err);
      setIsFetchingOffers(false); // error -> stop the loader (fall back to the form)
      // setCurrentStep(4);
      if (err.message === "No Offer Callback received") {
        setCurrentStep(6);
      }
      // toast.error(err.message || "Application Failed");
    } finally {
      setIsLoading(false);
    }
  };

  // Loader hands off here: once its bar reaches 100%, redirect to the target step.
  const handleLoaderComplete = () => {
    setIsFetchingOffers(false);
    setCurrentStep(nextStepRef.current);
  };

  const fetchOffers = async (leadId) => {
    if (!leadId || isFinished) return false;

    try {
      // Step 1: Get base offers
      const res = await callApi(
        `v1/loan_offer/lead_id/${leadId}`,
        "get",
        {},
        "core",
        user.token
      );

      if (res.status !== "Success" || !Array.isArray(res.data?.offers)) {
        return { success: false, offers: [] };
      }

      const baseOffers = res.data.offers;

      // Step 2: Get lender success + fail list
      const lenderListRes = await callApi(
        `v1/lender_api_call/${leadId}/get-fail-success-lenders`,
        "post",
        {},
        "loan",
        user.token
      );

      const failedList = lenderListRes.data?.FailListDetails ?? lenderListRes.data?.FailList ?? [];

      let lenderMap = {};
      if (
        lenderListRes.status === "Success" &&
        Array.isArray(lenderListRes.data?.Successlist)
      ) {
        lenderMap = Object.fromEntries(
          lenderListRes.data.Successlist.map((lender) => [
            lender.lender_id,
            lender,
          ])
        );
      }

      // Step 3: Enrich offers with lenderMap
      const enrichedOffers = baseOffers.map((offer) => {
        const lender = lenderMap[offer.lender_id] || {};

        return {
          ...offer,
          apr: lender.apr ?? "",
          kfs_doc: lender.kfs_doc ?? "",
          penal_charges: lender.penal_charges ?? "",
          processing_fee: lender.processing_fee ?? "",
          interest_rate: lender.web_interest ?? null,
          lender_name: lender.lender_name ?? offer.lender_name,
          rect_lender_logo: lender.rect_lender_logo ?? "",
          priority: lender.priority ?? offer.priority ?? 999,
        };
      });

      // Step 4: Sort by priority if available
      const sortedOffers = _.orderBy(enrichedOffers, ["priority"], ["asc"]);

      // Step 5: Apply active lender filter if needed
      const filteredOffers = activeLenders.length
        ? sortedOffers.filter((offer) =>
            activeLenders.some((lender) => lender._id === offer.lender_id)
          )
        : sortedOffers;

      return {
        success: true,
        offers: filteredOffers,
        failedList: failedList,
      };
    } catch (err) {
      console.error("Error in offer fetching", err);
      // toast.error("Something went wrong while fetching offers.");
      setIsFinished(true);
      return { success: false, offers: [] };
    }
  };

  if (isFetchingOffers)
    return (
      <LoadingScreen offersReady={offersReady} onComplete={handleLoaderComplete} />
    );

  return (
    <>
    <div className="dm-laststep-v9 w-full max-w-[400px] mx-auto bg-white px-4 pb-[120px] flex flex-col font-atkinson">
      {/* Progress (4/4) */}
      <div className="flex items-center gap-[14px] pt-2 pb-1">
        <button
          type="button"
          onClick={() => setCurrentStep("loan_amount")}
          aria-label="Go back"
          className="w-6 h-6 flex-none flex items-center justify-center"
        >
          <img src={process.env.PUBLIC_URL + "/assets/icons/left_arrow.png"} alt="" className="w-6 h-6 object-contain" />
        </button>
        <div className="flex-1 h-[7px] rounded-[6px] bg-[#c9f7e0] overflow-hidden">
          <div className="h-full bg-[#12f280] rounded-[6px]" style={{ width: "100%" }} />
        </div>
        <span className="text-[15px] text-[#3a3a3a] flex-none">4/4</span>
      </div>

      <h1 className="dm-type-header mt-[22px] text-[#1b1b1b]">Almost there…</h1>
      <p className="text-[17px] text-[#8b8b8b] mt-3">This helps us match you with relevant lenders.</p>

      {/* Profession type */}
      <div className="relative w-full h-[72px] flex flex-col justify-center border border-[#e6e6e6] rounded-[15px] px-4 mt-4">
        <div className="text-[12px] text-[#5f6066]">What's your occupation?</div>
        <select
          value={professionType}
          onChange={(e) => setProfessionType(e.target.value)}
          style={{ WebkitAppearance: "none", MozAppearance: "none", appearance: "none" }}
          className={"w-full bg-transparent outline-none appearance-none text-[16px] mt-[2px] " + (professionType ? "text-[#1b1b1b]" : "text-[#b3b3b3]")}
        >
          <option value=""></option>
          <option value="salaried">Salaried</option>
          <option value="self_employed">Self-employed</option>
          <option value="business">Business owner</option>
        </select>
        <svg className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#bdbdbd" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9l6 6 6-6" /></svg>
      </div>

      {/* Monthly income */}
      <div className="w-full h-[72px] flex flex-col justify-center border border-[#e6e6e6] rounded-[15px] px-4 mt-3">
        <div className="text-[12px] text-[#5f6066]">Monthly Income</div>
        <input
          inputMode="numeric"
          value={monthly_income ? new Intl.NumberFormat("en-IN").format(monthly_income) : ""}
          onChange={handleIncomeChange}
          placeholder="Your take-home salary per month"
          className="w-full bg-transparent outline-none text-[16px] text-[#1b1b1b] mt-[2px] placeholder:text-[#b3b3b3]"
        />
      </div>
      {errors.monthly_income && typeof errors.monthly_income === "string" && (
        <p className="text-[13px] text-red-500 mt-1 ml-1">{errors.monthly_income}</p>
      )}

      {/* Company name */}
      <div className="w-full h-[72px] flex flex-col justify-center border border-[#e6e6e6] rounded-[15px] px-4 mt-3">
        <div className="text-[12px] text-[#5f6066]">Company Name</div>
        <input
          value={company_name}
          onChange={(e) => {
            let v = e.target.value.replace(/[^A-Za-z\s]/g, "").replace(/\s+/g, " ");
            setcompany_name(v);
          }}
          placeholder="Name of your employer"
          className="w-full bg-transparent outline-none text-[16px] text-[#1b1b1b] mt-[2px] placeholder:text-[#b3b3b3]"
        />
      </div>

      {/* Purpose of Loan */}
      <div className="font-bold text-[12px] text-[#3a3a3a] mt-[26px]">Purpose of Loan</div>
      <div className="grid grid-cols-2 gap-[14px] mt-[14px]">
        {[
          { emoji: "🏠", label: "Renovation", value: "home renovation" },
          { emoji: "💊", label: "Medical", value: "medical expenses" },
          { emoji: "🎓", label: "Education", value: "education expenses" },
          { emoji: "✈️", label: "Travel", value: "travel expenses" },
          { emoji: "💵", label: "Debt PayOff", value: "debt payoff" },
          { emoji: "💍", label: "Wedding", value: "wedding/other events" },
          { emoji: "📦", label: "Other", value: "other personal use" },
        ].map((p) => (
          <button
            key={p.value}
            type="button"
            onClick={() => setloan_purpose(p.value)}
            className={"flex items-center justify-between bg-white rounded-[14px] px-4 h-[41px] border-[1.5px] " + (loan_purpose === p.value ? "border-[#12f280]" : "border-[#e9e9e9]")}
          >
            <span className="flex items-center gap-[8px] min-w-0">
              <span className="text-[15px] leading-none flex-none">{p.emoji}</span>
              <span className="text-[14px] text-[#1b1b1b] truncate">{p.label}</span>
            </span>
            <span
              className={"w-[15px] h-[15px] rounded-full flex-none border-[1.5px] " + (loan_purpose === p.value ? "border-[#12f280]" : "border-[#cfcfcf]")}
              style={loan_purpose === p.value ? { background: "radial-gradient(circle at center, #12f280 0 5px, #fff 5px 7px)" } : undefined}
            />
          </button>
        ))}
      </div>

      <div className="flex-1 min-h-[18px]" />
    </div>
    <StickyCtaBar>
      <button
        type="button"
        onClick={handleSubmit}
        id="professional-details-submit-v17"
        disabled={!(professionType && monthly_income && company_name && loan_purpose) || isLoading}
        className="w-full bg-black text-white font-bold text-[19px] rounded-[18px] py-[19px] active:scale-[0.99] transition-transform disabled:opacity-50"
      >
        Show My Offers
      </button>
    </StickyCtaBar>
    </>
  );
}

export default ProfessionalInformationForm;